{
	"ariaGallery": "gallery",
	"ariaMarkPhotoAsReference": "Mark Photo As AI Style Reference",
	"ariaPhotoGallery_one": "photo gallery, {{count}} photo",
	"ariaPhotoGallery_other": "photo gallery, {{count}} photos",
	"ariaResetFilters": "Reset Filters",
	"ariaToggleBatchPhotoEditLock": "Toggle Batch Photo Edit Lock",
	"lockEditing": "Lock Editing",
	"markReference": "Mark Reference",
	"noPhotosMatchingFilters": "No photos matching selected filters",
	"resetFilters": "Reset Filters",
	"ariaPhotoGallery": "photo gallery, {{count}} photos",
	"selectedCount": "{{count}} selected"
}
